import { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../../../../app/hooks";
import { RecordStatus } from "../../../../../utilities/interfaces/RecordStatus";
import { getRecordStatuses } from "../../../../../features/state/StateRecordStatus-slice";
import { useNotificationHelper } from "../../../../../utilities/helpers/NotificationHelper";
import { ChapterHistory } from '../../../../../utilities/interfaces/ChapterHistory';
import { chapterHistoryApi } from "../../../../../utilities/api/chapterHistoryApi";

export const useChapterHistoryFormController = (chapter: any, reloadChapterHistory: () => void) => {
    // Redux
    const recordStatuses: RecordStatus[] = useAppSelector((state) => state.recordStatuses.recordStatuses);

    // State
    const [selectedRecordStatus, setSelectedRecordStatus] = useState<any>();
    const [effectiveFromDate, setEffectiveFromDate] = useState<Date | null>();
    const [effectiveToDate, setEffectiveToDate] = useState<Date | null>();
    const [fileName, setFileName] = useState<string>('');
    const [blobName, setBlobName] = useState<string>('');

    const dispatch = useAppDispatch();
    const { addNotification } = useNotificationHelper();

    useEffect(() => {
        if (recordStatuses.length < 1) {
          dispatch(getRecordStatuses());
        }
      }, [recordStatuses, dispatch])


    // Functions
    const handleRecordStatusSelectChange = (event: any) => {
        setSelectedRecordStatus(event.value);
    }

    const saveFile = async (file: any) => {
        try {
            setFileName(file.fileName);
            setBlobName(file.blobName);
        } catch (error: any) {
            setFileName('');
            setBlobName('');
        }
      };

      const deleteFile = async (file: any) => {
        try {
            setFileName('');
            addNotification({type: 'success', message: 'File successfully deleted'});
          } catch (error: any) {
            addNotification({type: 'error', message: 'File failed to delete'});
          }
      };

      const handleFileUploadResponseMessage = (message: string, type: 'error' | 'success') => {
        addNotification({
          type: type,
          message: message,
        });
      };

      const handleSave = async (event?: any) => {
        try {
            if(event) {
                event.preventDefault();
            }

            if(validate() === false) {
                return;
            }

            let chapterHistory: ChapterHistory = {
                id: 0,
                chapterId: chapter.id,
                oldTitleId: chapter.titleId,
                recordStatusId: selectedRecordStatus.id,
                oldChapterName: chapter.chapterName,
                oldChapterNumber: chapter.chapterNumber,
                oldAppendixNumber: chapter.oldAppendixNumber,
                pdfBlobName: blobName,
                effectiveFrom: effectiveFromDate!,
                effectiveTo: effectiveToDate!
            };

            await chapterHistoryApi.save(chapterHistory);

            await reloadChapterHistory();

        } catch (error: any) {
            addNotification({type: 'error', message: 'Failed to add chapter history'});
        }
      }

      const validate = () => {
        let isValid: boolean = true;
        let messages: string[] = [];

        if(effectiveFromDate === null || effectiveFromDate === undefined) {
            isValid = false;
            messages.push('Effective From');
        }

        if(effectiveToDate === null || effectiveToDate === undefined) {
            isValid = false;
            messages.push('Effective To');
        }

        if(selectedRecordStatus === null || selectedRecordStatus === undefined) {
            isValid = false;
            messages.push('Record Status');
        }

        if(isValid === false) {
            addNotification({type: 'error', message: `${messages.join(', ')} is required`});
        }

        return isValid;
      }

    return{
        // Redux
        recordStatuses,

        // State
        selectedRecordStatus,

        // Functions
        handleRecordStatusSelectChange,
        setEffectiveFromDate,
        setEffectiveToDate,
        saveFile,
        deleteFile,
        handleFileUploadResponseMessage,
        handleSave
    };
}